import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  FormInstance,
  Image,
  Input,
  InputNumber,
  message,
  Row,
  Select
} from "antd";
import React, { FC, useCallback, useEffect, useMemo, useState } from "react";

//!API
import * as TOPICS_SERVICES from "api/services/topics/topics.services";

//!IMAGES
import LogoClasses from "assets/images/teacher/teacher_classes.svg";
import ArrowBack from "../../../../assets/images/app/arrow_back.svg";
import Book from "../../../../assets/images/app/book.png";
import Classroom from "../../../../assets/images/app/classroom.png";

//!STYLE
import {
  InfoCircleFilled
} from "@ant-design/icons";
import { StatusCode } from "common/enums";
import s from "./style.module.css";

type Props = {
  addCourse: (values: any) => void;
  showAddClasse: boolean;
  setShowAddClasse: React.Dispatch<React.SetStateAction<boolean>>;
  addCourseForm: FormInstance<any>;
  addCourseLoading: boolean;
  addOpenClass?: (values: any) => void;
  addPackClass?: (values: any) => void;
};

const { Option } = Select;

const AddRoom: FC<Props> = ({
  addCourse,
  showAddClasse,
  setShowAddClasse,
  addCourseForm,
  addCourseLoading,
  addOpenClass,
  addPackClass
}) => {
  //!STATES
  const [tempTopic, setTempTopic] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [addCourseError, setAddCourseError] = useState<string>("");
  const [currentStep, setCurrentStep] = useState<string>("Welcome");

  const [formPredefined] = Form.useForm();
  const [formOpen] = Form.useForm();

  const totalHours = Form.useWatch("totalHours", formPredefined);
  const totalPrice = Form.useWatch("totalPrice", formPredefined);

  const hourlyRate = useMemo(() => {
    if (!totalHours || !totalPrice) return 0;
    return (totalPrice / totalHours).toFixed(2);
  }, [totalHours, totalPrice]);

  const OnSelectLevel = useCallback(
    async (levelId: string) => {
      setLoading(true);
      try {
        const response = await TOPICS_SERVICES.findAll(levelId);

        if (response?.statusCode === StatusCode.OK) {
          setTempTopic(response?.data);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
    [tempTopic, loading]
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const onBack = () => {
    setCurrentStep("Welcome");
    formPredefined.resetFields();
    formOpen.resetFields();
  }

  const onClose = () => {
    setShowAddClasse(false)
    setCurrentStep("Welcome");
    formPredefined.resetFields();
    formOpen.resetFields();
  }

  const onFinish = async (values: any) => {
    console.log(values?.className);
    if (currentStep === "predefinedClassCreation") {
      if (!values?.className) {
        message.warning("Merci d'ajouter le nom de la classe");
        return;
      }
      if (!values?.totalHours) {
        message.warning("Merci d'ajouter le nombre d'heures'");
        return;
      }
      if (!values?.totalPrice) {
        message.warning("Merci d'ajouter le prix total");
        return;
      }
      if (!values?.endDate) {
        message.warning("Merci d'ajouter la date de fin");
        return;
      }
      addPackClass!(values);
    }
    else {
      if (!values?.className) {
        message.warning("Merci d'ajouter le nom de la classe");
        return;
      }
      addOpenClass!(values);
    }
  }

  useEffect(() => {
    if (!showAddClasse) {
      setCurrentStep("Welcome");
      formPredefined.resetFields();
      formOpen.resetFields();
    }
  }, [showAddClasse]);

  return (
    <Drawer
      className="drawer"
      title={false}
      placement="right"
      width={isMobile ? "100%" : "70%"}
      onClose={onClose}
      visible={showAddClasse}
      closable={true}
      headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
      closeIcon={
        <img
          src={ArrowBack}
          height={isMobile ? 10 : 18}
          style={{}}
        ></img>
      }
      drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
    >
      <div className={s.drawer}>
        <div className={s.drawer__content}>
          <div className={s.drawer___header}>
            <Image preview={false} src={LogoClasses} width={80} />
            <h3>Créer une classe</h3>
          </div>
        </div>

        {/* Header */}
        {currentStep === "Welcome" && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 40 }}>
          <h2 style={{ margin: 0, fontWeight: 600 }}>
            Choix du type de classe
          </h2>
        </div>}

        {/* Header */}
        {currentStep === "predefinedClassCreation" && <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
              src={ArrowBack}
              height={isMobile ? 10 : 15}
              onClick={onBack}
              style={{ cursor: "pointer" }}
            />
            <h2 style={{ margin: 0, fontWeight: 600 }}>
              Créer une classe avec pack prédéfini
            </h2>
          </div>
        </div>}

        {/* Header */}
        {currentStep === "openClassCreation" && <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
              src={ArrowBack}
              height={isMobile ? 10 : 15}
              onClick={onBack}
              style={{ cursor: "pointer" }}
            />
            <h2 style={{ margin: 0, fontWeight: 600 }}>
              Créer une classe ouverte
            </h2>
          </div>
        </div>}

        {/* Content */}
        {currentStep === "Welcome" && <Row gutter={32}>
          {/* PACK PRÉDÉFINI */}
          <Col xs={24} md={12}>
            <div style={cardStyle("#4c8bf5")} onClick={() => setCurrentStep("predefinedClassCreation")}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", width: "100%", marginBottom: "20px" }}>
                <div style={{ height: "40px", width: "40px", borderRadius: "50%", background: "#FFF", border: "1px solid #FAFAFA", display: "flex", alignItems: "center", justifyContent: "center" }}><img src={Classroom} height={20} /></div>
                <h3 style={{ fontWeight: 600 }}>Pack prédéfini</h3>
              </div>

              <p style={{ color: "#665", fontSize: "14px" }}>
                Pack d’heures fixe avec tarif global
              </p>

              <div style={infoBox("#e8f1ff", "#1d5fd0")}>
                <strong>Exemple:</strong>
                <div>10 Heures - 80€ ( 8€/heure )</div>
              </div>

              <div style={{ marginTop: 24 }}>
                <strong>Champs à définir:</strong>
                <ul style={{ paddingLeft: 0, color: "#665", marginTop: 12 }}>
                  <li>• Nom de la classe</li>
                  <li>• Nombre d’heures total</li>
                  <li>• Prix total du pack</li>
                  <li>• Date de début/fin (optionnel)</li>
                </ul>
              </div>
            </div>
          </Col>

          {/* CLASSE OUVERTE */}
          <Col xs={24} md={12}>
            <div style={cardStyle("#52c41a")} onClick={() => setCurrentStep("openClassCreation")}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", width: "100%", marginBottom: "20px" }}>
                <div style={{ height: "40px", width: "40px", borderRadius: "50%", background: "#FFF", border: "1px solid #FAFAFA", display: "flex", alignItems: "center", justifyContent: "center" }}><img src={Book} height={20} /></div>
                <h3 style={{ fontWeight: 600 }}>Classe ouverte</h3>
              </div>

              <p style={{ color: "#665", fontSize: "14px" }}>
                Cours individuels avec tarification flexible
              </p>

              <div style={infoBox("#e6f4ea", "#2e7d32")}>
                <strong>Caractéristiques</strong>
                <div>Nombre d’heures illimité</div>
                <div>Tarif définit par cours</div>
                <div>Paiement cours par cours</div>
              </div>

              <div style={{ marginTop: 24 }}>
                <strong>Champs à définir:</strong>
                <ul style={{ paddingLeft: 0, color: "#665", marginTop: 12 }}>
                  <li>• Nom de la classe</li>
                  <li>• Durée par défaut du cours</li>
                  <li>• Tarif par défaut</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>}

        {/* Form */}
        {currentStep === "predefinedClassCreation" && <Form
          layout="vertical"
          form={formPredefined}
          requiredMark="optional"
          initialValues={{
            totalHours: 10,
            totalPrice: 20,
          }}
          onFinish={onFinish}
        >
          {/* Class Name */}
          <Form.Item
            label="Nom de la classe"
            name="className"
            rules={[{ required: true, message: "Ce champ est obligatoire" }]}
          >
            <Input
              placeholder="e.g. nom de la classe"
              size="large"
              style={inputStyle}
            />
          </Form.Item>

          {/* Hours + Price */}
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="Nombre d’heures total"
                name="totalHours"
                rules={[{ required: true }]}
              >
                <InputNumber
                  min={1}
                  style={{ width: "100%", ...inputStyle }}
                  size="large"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Prix total du pack"
                name="totalPrice"
                rules={[{ required: true }]}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%", ...inputStyle }}
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Calculated Info Box */}
          <div style={predefinedInfoBoxStyle}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <InfoCircleFilled style={{ color: "#1d5fd0" }} />
              <strong>Tarif horaires calculé</strong>
            </div>

            <div style={{ marginTop: 8 }}>
              {hourlyRate}€ par heure (
              {totalHours || 0}h x {hourlyRate}€ = {totalPrice || 0}€)
            </div>
          </div>

          {/* Dates */}
          <Row gutter={24} style={{ marginTop: 24 }}>
            <Col span={12}>
              <Form.Item label="Date de début" name="startDate">
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%", ...inputStyle }}
                  size="large"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Date de fin" name="endDate" required>
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%", ...inputStyle }}
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* FOOTER BUTTONS */}
          <div style={footerStyle}>
            <Button
              size="large"
              style={cancelBtnStyle}
              onClick={onBack}
            >
              Annuler
            </Button>

            <Button
              type="primary"
              size="large"
              style={createBtnStyle}
              htmlType="submit"
            >
              Créer une classe
            </Button>
          </div>
        </Form>}

        {/* GREEN INFO BOX */}
        {currentStep === "openClassCreation" && <div style={openInfoBoxStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <InfoCircleFilled />
            <strong>Classe ouverte - À la carte</strong>
          </div>

          <div style={{ marginTop: 8 }}>
            Vous pourrez créer des cours individuels avec des tarifs
            personnalisés. Les élèves paieront chaque cours séparément.
          </div>
        </div>}

        {/* FORM */}
        {currentStep === "openClassCreation" && <Form
          layout="vertical"
          form={formOpen}
          requiredMark="optional"
          style={{ marginTop: 30 }}
          initialValues={{
            duration: 10,
            price: 20,
          }}
          onFinish={onFinish}
        >
          {/* CLASS NAME */}
          <Form.Item
            label="Nom de la classe"
            name="className"
            rules={[{ required: true, message: "Ce champ est obligatoire" }]}
          >
            <Input
              placeholder="e.g. nom de la classe"
              size="large"
              style={inputStyle}
            />
          </Form.Item>

          {/* FOOTER BUTTONS */}
          <div style={footerStyle}>
            <Button
              size="large"
              style={cancelBtnStyle}
              onClick={onBack}
            >
              Annuler
            </Button>

            <Button
              type="primary"
              size="large"
              style={createBtnStyle}
              htmlType="submit"
              disabled={addCourseLoading}
              loading={addCourseLoading}
            >
              Créer une classe
            </Button>
          </div>
        </Form>}
      </div>
    </Drawer>
  );
};

export default AddRoom;

const cardStyle = (color: string) => ({
  border: `1px solid ${color}`,
  borderRadius: 12,
  padding: 24,
  height: "100%",
  cursor: "pointer",
  transition: "all 0.3s ease",
  background: "#FAFAFA"
});

const infoBox = (bg: string, color: string) => ({
  background: bg,
  color: color,
  padding: 16,
  borderRadius: 8,
  marginTop: 16,
});

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 40,
};

const inputStyle = {
  borderRadius: 12,
};

const predefinedInfoBoxStyle = {
  background: "#e8f1ff",
  padding: 20,
  borderRadius: 12,
  marginTop: 10,
  color: "#1d5fd0",
};

const openInfoBoxStyle = {
  background: "#e6f4ea",
  padding: 20,
  borderRadius: 12,
  color: "#2e7d32",
  border: "1px solid #b7e4c7",
};

const footerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: 30,
  marginTop: 60,
};

const cancelBtnStyle = {
  width: 200,
  borderRadius: 30,
  height: 40,
  background: "#cfcfcf",
  border: "none",
  boxShadow: "3px 5px 1px -1px #868686",
  webkitBoxShadow: "5px 7px 1px -1px #868686",
  mozBoxShadow: "5px 7px 1px -1px #868686",
};

const createBtnStyle = {
  width: 220,
  borderRadius: 30,
  height: 40,
  background: "#7da7a6",
  border: "none",
  boxShadow: "3px 5px 1px -1px #5a8484",
  webkitBoxShadow: "5px 7px 1px -1px #5a8484",
  mozBoxShadow: "5px 7px 1px -1px #5a8484",
};

